module.exports = __webpack_public_path__ + "static/media/396SunsetAveNW_2018-06-11_157.bc8fb560.jpg";